var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-logo",style:(_vm.getStyle())})
}
var staticRenderFns = []

export { render, staticRenderFns }